import { createRef } from 'react';
import { Settings } from 'lucide-react';
import SettingsMenu from './SettingsMenu';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../hooks/useWindowSize';
import MyDrawer from '../../components/myDrawer/MyDrawer';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';

const SettingsLayoutMenu = () => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();

  const refDrawer = createRef(null);

  const onCloseToggle = () => {
    refDrawer?.current?.closeDrawer();
  };

  return isMobile ? (
    <div className="settings_layout_icon_mobile">
      <MyDrawer
        ref={refDrawer}
        title={t('WORD_SETTINGS')}
        closable={{ placement: 'end' }}
        size={280}
        btnStyle={{ width: 46 }}
        icon={<MyLucideIcon icon={Settings} />}
        className="settings_drawer"
        noExtraBtn
      >
        <div className="margin_bottom">
          <SettingsMenu onSelect={onCloseToggle} />
        </div>
      </MyDrawer>
    </div>
  ) : (
    <SettingsMenu />
  );
};

export default SettingsLayoutMenu;
